const topbar = document.querySelector('.js-topbar');
const nav = document.querySelector('.js-nav');
const body = document.body;

function handleHeaderScroll() {
  const compact = window.scrollY > 30;

  topbar?.classList.toggle('is-compact', compact);
  nav?.classList.toggle('is-compact', compact);
  body.classList.toggle('is-compact', compact);
}

window.addEventListener('scroll', handleHeaderScroll);
handleHeaderScroll();

const navToggle = document.querySelector('.js-nav-toggle');
const navPanel = document.querySelector('.js-nav-panel');

function closeNavPanel() {
  nav?.classList.remove('is-open');
  navToggle?.setAttribute('aria-expanded', 'false');
}

function toggleNavPanel() {
  const isOpen = nav?.classList.toggle('is-open');
  navToggle?.setAttribute('aria-expanded', String(!!isOpen));
}

navToggle?.addEventListener('click', (event) => {
  event.stopPropagation();
  toggleNavPanel();
});

navPanel?.addEventListener('click', (event) => {
  if (event.target.closest('a, button')) {
    closeNavPanel();
  }
});

document.addEventListener('click', (event) => {
  if (nav && !nav.contains(event.target)) {
    closeNavPanel();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeNavPanel();
  }
});

window.addEventListener('resize', closeNavPanel);
